import { Box, Paper, Typography } from '@mui/material';

const Faq = () => (
  <Box sx={{ bgcolor: '#F5F7FA', minHeight: 'calc(100vh - 64px)', p: { xs: 2, md: 4 } }}>
    <Box sx={{ maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color: '#002A5C', mb: 0.5 }}>
        FAQ
      </Typography>
      <Typography variant="body2" sx={{ color: '#5C6B7A', mb: 3 }}>
        Frequently asked questions about TechnoDB.
      </Typography>

      <Paper
        elevation={0}
        sx={{
          borderRadius: 3,
          border: '1px solid #DEE3EA',
          p: { xs: 2, md: 4 },
          bgcolor: 'white',
        }}
      >
        <Typography variant="body1" sx={{ color: '#5C6B7A', textAlign: 'center', py: 6 }}>
          Content coming soon.
        </Typography>
      </Paper>
    </Box>
  </Box>
);

export default Faq;
